import styled from "styled-components";

export default function TermsAndConditions() {
  return (
    <Wrapper>
      <Container className="container">
        <Content>
          <Header>
            <h1>Terms & Conditions</h1>
            <p>
              These Terms and Conditions govern access to and use of the OnePayX
              digital payment and related services operated by YOYA Technologies
              Limited.
            </p>
            <Meta>Effective Date: Wednesday, 17 December 2025</Meta>
          </Header>

          {/* INDIVIDUAL USERS */}
          <Section>
            <h2>1. Terms & Conditions – Individual Users</h2>

            <h3>1.1 Eligibility and Legal Capacity</h3>
            <p>
              OnePayX services are available only to individuals who are at
              least eighteen (18) years of age and possess legal capacity under
              the laws of Uganda.
            </p>

            <h3>1.2 Account Registration and KYC</h3>
            <p>
              Users must complete registration and identity verification,
              including submission of personal information such as full name,
              phone number, National Identification Number (NIN), and date of
              birth.
            </p>

            <h3>1.3 Use of Services and Prohibited Activities</h3>
            <ul>
              <li>Fraud, impersonation, or misrepresentation</li>
              <li>Money laundering or terrorist financing</li>
              <li>Bribery, corruption, or illegal collections</li>
              <li>Unauthorised government revenue collection</li>
              <li>Any activity prohibited under Ugandan law</li>
            </ul>

            <h3>1.4 Transactions, Limits, and Controls</h3>
            <p>
              Transaction limits and wallet controls apply in line with
              regulatory guidance and verification levels.
            </p>

            <h3>1.5 Fees and Charges</h3>
            <p>
              Applicable fees are disclosed prior to transaction confirmation.
            </p>

            <h3>1.6 Suspension and Termination</h3>
            <p>
              OnePayX may suspend or terminate accounts where there is
              reasonable suspicion of fraud or regulatory non-compliance.
            </p>

            <h3>1.7 Liability and Consumer Protection</h3>
            <p>
              Losses resulting from negligence or credential compromise may not
              be recoverable. Statutory consumer rights remain unaffected.
            </p>

            <h3>1.8 Governing Law</h3>
            <p>
              These Terms are governed by the laws of the Republic of Uganda.
            </p>
          </Section>

          {/* MERCHANT TERMS */}
          <Section>
            <h2>2. Merchant Terms & Conditions</h2>

            <h3>2.1 Merchant Onboarding</h3>
            <p>
              Merchants must provide valid registration documents, TIN, physical
              address, authorised signatories, and settlement account details.
            </p>

            <h3>2.2 Payment Acceptance</h3>
            <p>
              Merchants may accept payments via QR, POS, APIs, NFC, or USSD for
              authorised goods and services only.
            </p>

            <h3>2.3 Settlement and Reconciliation</h3>
            <p>
              Merchant funds are settled through escrow-backed accounts with
              regulated Ugandan financial institutions.
            </p>

            <h3>2.4 Fees, Delays, and Withholding</h3>
            <p>
              OnePayX may delay or withhold settlement where transactions are
              under investigation or required by law.
            </p>

            <h3>2.5 Disputes and Audits</h3>
            <p>
              Merchants agree to cooperate fully in dispute resolution and audit
              processes.
            </p>
          </Section>

          {/* DISCLAIMERS */}
          <Section>
            <h2>3. Regulatory Disclaimers</h2>

            <h3>E-Money Issuance Disclaimer</h3>
            <p>
              Stored value does not constitute a bank deposit and does not earn
              interest.
            </p>

            <h3>Escrow & Settlement Disclaimer</h3>
            <p>
              Customer and merchant funds are held in segregated escrow accounts
              and are not commingled with OnePayX operational funds.
            </p>
          </Section>

          {/* SECURITY */}
          <Section>
            <h2>4. Security, Risk & Trust Framework</h2>
            <ul>
              <li>End-to-end encryption</li>
              <li>Tokenisation of sensitive data</li>
              <li>Role-based access control</li>
              <li>Audit logs and fraud monitoring</li>
            </ul>
          </Section>

          {/* SLA */}
          <Section>
            <h2>5. Service Levels & Uptime</h2>
            <p>
              OnePayX targets platform availability of 99.5%, excluding
              scheduled maintenance and force majeure events.
            </p>
          </Section>

          {/* KNOWLEDGE BASE */}
          <Section>
            <h2>6. User & Merchant Knowledge Base</h2>

            <h3>Individuals</h3>
            <ul>
              <li>Register using a Ugandan mobile number</li>
              <li>Safeguard your PIN</li>
              <li>Withdraw funds to supported channels</li>
            </ul>

            <h3>Merchants</h3>
            <ul>
              <li>Complete onboarding verification</li>
              <li>Accept payments via approved channels</li>
              <li>Access reconciliation dashboards</li>
            </ul>
          </Section>
        </Content>
      </Container>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  background: #f8fafc;
  padding: 20px;
`;

const Container = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 50px 40px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);

  @media (max-width: 768px) {
    padding: 30px 20px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const Header = styled.div`
  text-align: center;

  h1 {
    font-size: 2.2rem;
    color: #0f172a;
    margin-bottom: 12px;
  }

  p {
    max-width: 700px;
    margin: 0 auto;
    color: #475569;
    line-height: 1.7;
  }
`;

const Meta = styled.div`
  margin-top: 12px;
  font-size: 0.9rem;
  color: #64748b;
`;

const Section = styled.div`
  h2 {
    font-size: 1.5rem;
    color: #0f172a;
    margin-bottom: 15px;
  }

  h3 {
    font-size: 1.1rem;
    margin: 20px 0 10px;
    color: #334155;
  }

  p {
    color: #475569;
    line-height: 1.8;
    margin-bottom: 12px;
  }

  ul {
    padding-left: 20px;

    li {
      margin-bottom: 8px;
      color: #475569;
      line-height: 1.6;
    }
  }
`;
